/**
 *   Generated file. Do not edit
 */

import { ModbusVariableAddress } from './models';
import { VariableType } from './models';
import { VariableMeta } from './models';
import { ReadWriteRights } from '@iotize/tap/service/impl/bundle';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

import { bundleConverters } from '@iotize/tap/service/impl/bundle';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,

  ...bundleConverters,
};

export const SERVICE_CALLS = {
  getVariableAddress: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/variable-address',
    path: '/1029/{variableId}/0',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putVariableAddress: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/variable-address',
    path: '/1029/{variableId}/0',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  putModbusVariableAddress: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/modbus-variable-address',
    path: '/1029/{variableId}/0',
    bodyEncoder: allConverters.modbusVariableAddress,
  } as ServiceCallType<ModbusVariableAddress, void>,

  getType: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/type',
    path: '/1029/{variableId}/1',
    responseBodyDecoder: allConverters.variableType,
  } as ServiceCallType<void, VariableType>,

  putType: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/type',
    path: '/1029/{variableId}/1',
    bodyEncoder: allConverters.variableType,
  } as ServiceCallType<VariableType, void>,

  getRawMeta: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/raw-meta',
    path: '/1029/{variableId}/8',
  } as ServiceCallType<void, Uint8Array>,

  putRawMeta: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/raw-meta',
    path: '/1029/{variableId}/8',
  } as ServiceCallType<Uint8Array, void>,

  getMeta: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/meta',
    path: '/1029/{variableId}/8',
    responseBodyDecoder: allConverters.variableMeta,
  } as ServiceCallType<void, VariableMeta>,

  putMeta: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/meta',
    path: '/1029/{variableId}/8',
    bodyEncoder: allConverters.variableMeta,
  } as ServiceCallType<VariableMeta, void>,

  getUnit: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/unit',
    path: '/1029/{variableId}/9',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putUnit: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/unit',
    path: '/1029/{variableId}/9',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getNumberOfElements: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/number-of-elements',
    path: '/1029/{variableId}/2',
    responseBodyDecoder: allConverters.uint8,
  } as ServiceCallType<void, number>,

  putNumberOfElements: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/number-of-elements',
    path: '/1029/{variableId}/2',
    bodyEncoder: allConverters.uint8,
  } as ServiceCallType<number, void>,

  getCurrentAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/current-access',
    path: '/1029/{variableId}/3',
    responseBodyDecoder: allConverters.readWriteRights,
  } as ServiceCallType<void, ReadWriteRights>,

  readProfile: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/read-profile',
    path: '/1029//4',
  } as ServiceCallType<void, Uint8Array>,

  getValue: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/value',
    path: '/1029/{variableId}/4',
  } as ServiceCallType<void, Uint8Array>,

  setValue: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/variable/{variableId}/value',
    path: '/1029/{variableId}/5',
  } as ServiceCallType<Uint8Array, void>,

  putValue: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/value',
    path: '/1029/{variableId}/4',
  } as ServiceCallType<Uint8Array, void>,

  getBundleId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/bundle/id',
    path: '/1029/{variableId}/6',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleId: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/variable/{variableId}/bundle/id',
    path: '/1029/{variableId}/6',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleValues: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/bundle/values',
    path: '/1029/{variableId}/7',
  } as ServiceCallType<void, Uint8Array>,

  create: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/variable/{variableId}/create',
    path: '/1029/{variableId}/65535',
    bodyEncoder: allConverters.uint8,
  } as ServiceCallType<number, void>,
};
